///<amd-module name="typeahead/client/HotelSearchResultsPageHandler" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

import {ClientHandlerRegistry, IClientHandler, IHsrpSubmitData} from "typeahead/client/ClientHandlerRegistry";
import {GeolocationDataProvider} from "typeahead/core/geolocation/GeolocationDataProvider";
import {GeolocationViewController} from "typeahead/core/geolocation/GeolocationViewController";
import {HsrpGeolocationViewController} from "typeahead/core/geolocation/HsrpGeolocationViewController";
import {FormLoadedMessage} from "typeahead/core/message/FormLoadedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class HotelSearchResultsPageHandler implements IClientHandler {
    private static readonly APPLICABLE_CLIENT_ID = "Hotels.Search";
    private static readonly SEARCH_WIZARD_OPENED_MESSAGE = "toggle.opened";
    private static readonly SEARCH_WIZARD_TOGGLE_BUTTON_ID = "changeSearchWizard";
    private latLong: string;
    private geolocationViewController: GeolocationViewController;

    public isApplicable(clientId: string): boolean {
        return HotelSearchResultsPageHandler.APPLICABLE_CLIENT_ID === clientId;
    }

    public subscribeFormSubmitEvent(): void {
        let that = this;

        $("form").on("click", "button[type=submit]", (event) => {
            if ($(event.target).parents("form:has(input[data-provide=utypeahead])").length > 0) {
                let rfrrIdPrefix = $(event.target).data("track"); // rfrrIdPrefix=HOT.SR.UpdateSearch
                rfrrIdPrefix = rfrrIdPrefix.match(/(\w+).(\w+)/g)[0] + "|" + rfrrIdPrefix.match(/(\w+).(\w+)/g)[1];
                // rfrrIdPrefix=HOT.SR|UpdateSearch
                $(event.target).removeAttr("data-track");

                ClientHandlerRegistry.publishSubmitClickedMessage(rfrrIdPrefix);
            }
        });

        uitk.subscribe(ClientHandlerRegistry.HSR_SUBMIT_SHOW_ERRORS_MESSAGE,
            (topic: string, submitObject: IHsrpSubmitData) => {
            ClientHandlerRegistry.publishFormSubmittedMessage(submitObject.isValid);
        });

        uitk.subscribe(ClientHandlerRegistry.HSR_SUBMIT_GET_QUERY_MESSAGE,
            (topic: string, submitObject: IHsrpSubmitData) => {
            this.setLatLongForCurrentLocation(submitObject);
        });
    }

    public subscribeFormLoadedEvent(): void {
        uitk.subscribe(HotelSearchResultsPageHandler.SEARCH_WIZARD_OPENED_MESSAGE,
            (message: string, $target: JQuery) => {
            if (HotelSearchResultsPageHandler.SEARCH_WIZARD_TOGGLE_BUTTON_ID === $target.attr("id")) {
                TypeaheadMessage.publish(new FormLoadedMessage(undefined));
            }
        });
    }

    public getTab(): string {
        return undefined;
    }

    public getGeolocationViewController(geolocationDataProvider: GeolocationDataProvider): GeolocationViewController {
        if (!this.geolocationViewController) {
            this.geolocationViewController = new HsrpGeolocationViewController(geolocationDataProvider);
        }
        return this.geolocationViewController;
    }

    private setLatLongForCurrentLocation(submitObject: IHsrpSubmitData) {
        let latLong: string = this.getLatLongFromUrl();
        if (this.isDestinationCurrentLocation() && latLong) {
            $("#latLong").val(latLong);
            if (submitObject.query && submitObject.query.indexOf("latLong") === -1) {
                submitObject.query += "&latLong=" + latLong;
            }
        }
    }

    private getLatLongFromUrl(): string {
        let sanitize = (latLong: string): string => {
            return (latLong && latLong.match(/^[+-]?\d+\.\d+,[+-]?\d+\.\d+$/)) ? latLong : undefined;
        };
        return sanitize(this.getRequestParameterValue("latLong"));
    }

    private isDestinationCurrentLocation(): boolean {
        let compareAndSanitize = (destination: string): boolean => {
            if (destination) {
                destination = destination.replace(/\+/g, " ");
                return (loc.geolocationDisplayText === $("#inpSearchNear").val() &&
                    loc.geolocationDisplayText ===  destination);
            }
            return false;
        };
        return compareAndSanitize(this.getRequestParameterValue("destination"));
    }

    private getRequestParameterValue(parameter: string): string {
        let result = new RegExp(parameter + "=([^&]*)&?").exec(decodeURIComponent(window.location.href));
        if (result && result.length && result[1]) {
            return result[1];
        }
        return undefined;
    }
}
